import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProjectState {
    id: string,
    name: string,
    isLoop: boolean,
    getExportAPIURL: string,
    getExportAPIKey: string,
    getLastRunDate: string,
    getDateOfCreation: string,
    isThereBlockExpanded: boolean
}

const initialState: ProjectState = {
    id: '',
    name: '',
    isLoop: false,
    getExportAPIURL: '',
    getExportAPIKey: '',
    getLastRunDate: '',
    getDateOfCreation: '',
    isThereBlockExpanded: false
}

export const projectSlice = createSlice({
    name: 'project',
    initialState,
    reducers: {
        setProjectData: (state, action: PayloadAction<Partial<ProjectState>>) => {
            Object.assign(state, action.payload);
        },
    },
});

export const { setProjectData } = projectSlice.actions;
export default projectSlice.reducer;